import type { ApplicationSettings } from '../store/schema/ApplicationSettings';
import type { ApplicationSettingsError, ApplicationSettingsReport } from 'owa-analytics-types';

export const generateApplicationSettingsReport = (
    receivedSettings: ApplicationSettings,
    receivedSettingsType: string,
    filters: string,
    ecsConfigIds: string,
    ecsETag?: string | null,
    lastError?: ApplicationSettingsError
): ApplicationSettingsReport<ApplicationSettings> => {
    const report = {} as ApplicationSettingsReport<ApplicationSettings>;
    if (receivedSettingsType) {
        report.Type = receivedSettingsType;
    }

    report.Settings = receivedSettings;
    report.Filters = filters;
    report.EcsConfigIds = ecsConfigIds;

    // EcsETag is optional and only populated once the server exposes it on the
    // boot configuration. When absent the report omits the field entirely so
    // downstream stamping/serialization stays a no-op.
    if (ecsETag) {
        report.EcsETag = ecsETag;
    }

    if (lastError) {
        report.LastError = lastError;
    }

    return report;
};

export interface NoSettingsReport {
    NoSettings: boolean;
    LastError: ApplicationSettingsError;
}

export const getNoSettingsReport = (settingsError: ApplicationSettingsError): NoSettingsReport => ({
    NoSettings: true,
    LastError: settingsError,
});
